import { useEffect, useState } from 'react';
import { fetchUserAchievements } from 'Api/achievements';

const useFetchAchievements = ({ userId }) => {
  const [userAchievements, setUserAchievements] = useState();

  useEffect(() => {
    if (!userId) return;

    fetchUserAchievements({ userId }).then(data => {
      setUserAchievements(data || []);
    });
  }, [userId]);

  return { userAchievements };
};

export default useFetchAchievements;
